module.exports = __webpack_public_path__ + "img/default-user.fd513470.svg";